import React from 'react';
import { DownloadAppHover } from '../styled';
import {
  downloadAppHandler,
  downloadAppleAppHandler,
} from '../../../../Utils/redirections';
import { images } from '../../../../Constants/ImageUrls';

function DownloadApp(props) {
  const downloadAppData = {
    heading: 'Get MYLO APP',
    subHeading: 'Install Mylo app Now and unlock new features',
    featureList: [
      '💰 Extra 20% OFF on 1st purchase',
      '🥗 Get Diet Chart for your little one',
      '📈 Track your baby’s growth',
      '👩‍⚕️ Get daily tips',
    ],
  };
  return (
    <DownloadAppHover>
      <div className="leftSection">
        <p className="heading">{downloadAppData?.heading}</p>
        <p className="subHeading">{downloadAppData?.subHeading}</p>
        <div className="featureList">
          {downloadAppData.featureList?.map((ele, index) => {
            return (
              <p key={`list_${index}`} className="listElement">
                {ele}
              </p>
            );
          })}
        </div>
      </div>
      <div className="rightSection">
        <div className="imageParent">
          <img
            className="qrCode"
            src={
              'https://images.myloapp.in/NestJsUploads/1735557905655-qr_playstore.webp'
            }
            alt=""
          />
        </div>

        <div className="orSeperator">
          <p className="orText">OR</p>
          <p className="seperator"></p>
        </div>

        <div className="installIcons">
          <img
            loading="lazy"
            onClick={downloadAppHandler}
            src={
              'https://images.myloapp.in/NestJsUploads/1668598861483-GooglePlay.webp'
            }
            alt=""
          />
          <img
            className="appleImage"
            loading="lazy"
            onClick={downloadAppleAppHandler}
            src={images.appstore}
            alt=""
          />
        </div>
      </div>
    </DownloadAppHover>
  );
}

export default DownloadApp;
